import CrudCustom from '../../../libs/custom/CrudCustom';

let SaldoAwalService = new CrudCustom('/saldo-neraca-awals');
export default SaldoAwalService;
